import * as React from "react";
import * as _ from "underscore";
import { Button } from "react-bootstrap";
import Select from "react-select";

import { AppShape, EmploymentShape } from "@eave/shared/types/api";
import { addressToStr } from "../../shared";
import { loadApp } from "../../actions";
import APIClient from "../../../APIClient";
import LabeledInput from "../../../LabeledInput";
import AddressFieldsWithValidation from "../../../AddressFieldsWithValidation";

export const ContactMethodDocusign = "docusign";

interface WVoERequestFormProps {
  app: AppShape;
  employment: EmploymentShape;
  dispatch?: Function;
}

class WVoERequestForm extends React.Component<WVoERequestFormProps, any> {
  constructor(props) {
    super(props);
    const wvoe = props.employment.wvoe_signature_request;
    this.state = {
      contactMethod: wvoe.contact_method || "",
      contactName: wvoe.contact_name || "",
      emailAddress: wvoe.contact_email || "",
      employerName: wvoe.employer_name || "",
      employerAddressLine1: wvoe.employer_address_line1 || "",
      employerAddressLine2: wvoe.employer_address_line2 || "",
      employerAddressCity: wvoe.employer_address_city || "",
      employerAddressState: wvoe.employer_address_state || "",
      employerAddressPostalCode: wvoe.employer_address_postal_code || "",
    };
  }

  handleAddressChange(address) {
    this.setState({
      employerAddressLine1: address.address_line1,
      employerAddressLine2: address.address_line2,
      employerAddressCity: address.city,
      employerAddressState: address.state,
      employerAddressPostalCode: address.postal_code,
    });
  }

  render() {
    return <div>{this.renderSendToBorrowerSection()}</div>;
  }

  formCompleted() {
    return (
      _.chain(this.state)
        .omit("employerAddressLine2")
        .values()
        .filter(val => val === "")
        .value().length === 0
    );
  }

  requestEmployeeSignature() {
    if (!this.formCompleted()) {
      alert("All fields must be filled out first.");
    } else {
      const vals = {
        application_id: this.props.app.id,
        contact_method: this.state.contactMethod,
        contact_email: this.state.emailAddress,
        contact_name: this.state.contactName,
        employer_name: this.state.employerName,
        employer_address_line1: this.state.employerAddressLine1,
        employer_address_line2: this.state.employerAddressLine2,
        employer_address_city: this.state.employerAddressCity,
        employer_address_state: this.state.employerAddressState,
        employer_address_postal_code: this.state.employerAddressPostalCode,
      };
      const { app, dispatch, employment } = this.props;

      APIClient.post(`/${app.id}/populate_wvoe/${employment.id}`, vals).then(() => {
        loadApp(dispatch, app.id);
      });
    }
  }

  renderSendToBorrowerSection() {
    if (
      this.props.employment.wvoe_signature_request.id === 0 ||
      this.props.employment.wvoe_signature_request.envelope_id === null
    ) {
      return (
        <div>
          <p>Please call the employer for the following information:</p>
          <p>How would the employer prefer to receive the Verification of Employment form?</p>
          <Select
            value={this.state.contactMethod}
            clearable={false}
            options={[
              { value: ContactMethodDocusign, label: "Docusign" },
              { value: "email", label: "E-mail" },
              { value: "snail_mail", label: "Snail Mail" },
              { value: "fax", label: "Fax" },
              { value: "other", label: "Other" },
            ]}
            onChange={e => this.setState({ contactMethod: e.value })}
          />
          <LabeledInput
            labelValue="Full Name"
            inputType="text"
            inputName="full_name"
            inputValue={this.state.contactName}
            onChange={e => this.setState({ contactName: e.target.value })}
          />
          <LabeledInput
            labelValue="Email Address"
            inputType="text"
            inputName="email_address"
            inputValue={this.state.emailAddress}
            onChange={e => this.setState({ emailAddress: e.target.value })}
          />
          <LabeledInput
            labelValue="Employer Name"
            inputType="text"
            inputName="employer_name"
            inputValue={this.state.employerName}
            onChange={e => this.setState({ employerName: e.target.value })}
          />
          <AddressFieldsWithValidation
            callback={this.handleAddressChange.bind(this)}
            address_line1={this.state.employerAddressLine1}
            address_line2={this.state.employerAddressLine2}
            city={this.state.employerAddressCity}
            state={this.state.employerAddressState}
            postal_code={this.state.employerAddressPostalCode}
          />
          <p>
            <Button
              bsSize="small"
              onClick={this.requestEmployeeSignature.bind(this)}
              disabled={!this.formCompleted()}
            >
              <i className="fa fa-check-circle" />
              Send to Borrower for Signature
            </Button>
          </p>
        </div>
      );
    }
    return (
      <dl>
        <dt>How would the employer prefer to receive the Verification of Employment form?</dt>
        <dd>{this.state.contactMethod}</dd>
        <dt>Employer Contact - Full Name</dt>
        <dd>{this.state.contactName}</dd>
        <dt>Employer Contact - Email Address</dt>
        <dd>{this.state.emailAddress}</dd>
        <dt>Employer Name</dt>
        <dd>{this.state.employerName}</dd>
        <dt>Employer Address</dt>
        <dd>
          {addressToStr(
            this.state.employerAddressLine1,
            this.state.employerAddressLine2,
            this.state.employerAddressCity,
            this.state.employerAddressState,
            this.state.employerAddressPostalCode,
          )}
        </dd>
      </dl>
    );
  }
}

export default WVoERequestForm;
